import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["name", "className"];
import React from 'react';
import { useThemeType } from '@gravity-ui/uikit';
import merge from 'lodash/merge';
import { SvgImage } from '../SvgImage/SvgImage';
import { block } from '../cn';
import { importContext, isContext } from './context';
var baseStore = {
  light: {
    403: function _() {
      return import('../../assets/illustrations/light/403');
    },
    404: function _() {
      return import('../../assets/illustrations/light/404');
    },
    500: function _() {
      return import('../../assets/illustrations/light/500');
    },
    support: function support() {
      return import('../../assets/illustrations/light/support');
    }
  },
  dark: {
    403: function _() {
      return import('../../assets/illustrations/dark/403');
    },
    404: function _() {
      return import('../../assets/illustrations/dark/404');
    },
    500: function _() {
      return import('../../assets/illustrations/dark/500');
    },
    support: function support() {
      return import('../../assets/illustrations/dark/support');
    }
  }
};
var b = block('illustration');
export function createIllustration() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var customStores = items.map(function (item) {
    if (isContext(item)) {
      return importContext(item);
    } else {
      return item;
    }
  });
  var store = merge.apply(void 0, [{}, baseStore].concat(_toConsumableArray(customStores)));

  function Illustration(_ref) {
    var name = _ref.name,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, _excluded);

    var theme = useThemeType();
    var src = store[theme] && store[theme][name];
    return /*#__PURE__*/React.createElement(SvgImage, Object.assign({
      alt: name,
      src: src,
      className: b(null, className)
    }, props));
  }

  return Illustration;
}
export var Illustration = createIllustration();
// #sourceMappingURL=Illustration.js.map